import { Pagination } from '../Entities/pagination.interface';
import { DataPagination } from '.';

export default function adapterDataPagination(
	pagination: Pagination,
	elements = -1,
	value = 0,
	totalPrevius = -1,
	pageToPrev = -1
): DataPagination {
	const page = pagination?.current > 1 ? pagination.current * 10 - 9 : pagination?.current || 0;
	const total = elements === -1 ? pagination?.count : totalPrevius + value;

	let pageTo = 0;
	if (elements !== -1) {
		if (pagination?.current === 1) {
			pageTo = elements + value;
		} else {
			pageTo = pageToPrev + value;
		}
	} else {
		pageTo =
			pagination?.current * 10 > pagination?.count ? pagination?.count : pagination?.current * 10;
	}
	return {
		page,
		pageTo,
		total,
		pages: pagination?.pages,
		previous: pagination?.previous,
		next: pagination?.next,
	};
}
